import { formatTime } from "./chatUtils";
import { StatusBadge } from "./StatusIcon";

const ConversationItem = ({ conv, isActive, onClick }) => {
  const name = conv.customer?.name || conv.waId;
  const initials = name.slice(0, 2).toUpperCase();

  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-4 py-3 border-b border-gray-100 hover:bg-gray-50 transition-colors ${
        isActive ? "bg-blue-50 border-l-4 border-l-blue-500" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
          {initials}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-center mb-0.5">
            <div className="flex items-center gap-1.5 min-w-0">
              <span className="text-sm font-semibold text-gray-900 truncate">{name}</span>
              {conv.customer?.status === false && (
                <span className="text-[10px] px-1.5 py-0.5 rounded bg-red-100 text-red-600 font-medium flex-shrink-0">
                  Opted out
                </span>
              )}
            </div>
            <span className="text-xs text-gray-400 flex-shrink-0 ml-2">{formatTime(conv.lastMessageAt)}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-xs text-gray-500 truncate">{conv.waId}</span>
            <div className="flex items-center gap-1.5 flex-shrink-0 ml-2">
              {conv.unreadCount > 0 && (
                <span className="bg-green-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                  {conv.unreadCount > 99 ? "99+" : conv.unreadCount}
                </span>
              )}
              <StatusBadge status={conv.status} />
            </div>
          </div>
          {conv.customer?.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1">
              {conv.customer.tags.slice(0, 3).map((tag) => (
                <span
                  key={tag.id}
                  className="inline-block text-white text-xs px-1.5 py-0.5 rounded-full font-medium leading-none"
                  style={{ backgroundColor: tag.color }}
                >
                  {tag.name}
                </span>
              ))}
              {conv.customer.tags.length > 3 && (
                <span className="text-xs text-gray-400">+{conv.customer.tags.length - 3}</span>
              )}
            </div>
          )}
          {!conv.canSendFreeForm && (
            <p className="text-xs text-orange-500 mt-0.5">Template only — window expired</p>
          )}
        </div>
      </div>
    </button>
  );
};

export default ConversationItem;
